import { Tags } from 'lucide-react';
import { useTranslation } from '@dukanti/shared';
import { Button } from '@/components/ui/button';

export interface CategoriesEmptyStateProps {
  readonly onCreate: () => void;
}

export function CategoriesEmptyState({ onCreate }: CategoriesEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="categories-empty-state"
      className="border-border bg-card shadow-admin-card mx-auto max-w-lg rounded-lg border p-8 text-center"
    >
      <div className="bg-zaatar-wash text-zaatar-deep mx-auto mb-4 flex size-14 items-center justify-center rounded-full">
        <Tags className="size-7" strokeWidth={1.75} aria-hidden />
      </div>
      <h2 className="font-display text-foreground text-xl font-semibold">
        {t('admin.categories.empty.title')}
      </h2>
      <p className="text-muted-foreground mx-auto mt-2 max-w-sm text-sm">
        {t('admin.categories.empty.subtitle')}
      </p>
      <Button type="button" className="mt-5" onClick={onCreate}>
        {t('admin.categories.empty.cta')}
      </Button>
    </div>
  );
}
